import { NavLink } from "react-router-dom";

const TopMenu = () => {


  return (
<nav className="navbar navbar-expand-lg navbar-dark bg-primary py-0 ">

      <div className="container-fluid">
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">

            <li className="nav-item">
              <NavLink className="nav-link " to="/case-manager/work-orders-active">Home</NavLink>
            </li>
            <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="reportDropDown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          Work Order
          </a>
          <ul className="dropdown-menu" aria-labelledby="reportDropDown">
          <li className="nav-item">
             <NavLink className="nav-link" to="/case-manager/work-orders-new">   NEW WORK ORDER  </NavLink>
                    </li>

                    <li className="nav-item">
             <NavLink className="nav-link" to="/case-manager/work-orders-search">   SEARCH WORK ORDER  </NavLink>
                    </li>

                    <li className="nav-item">
             <NavLink className="nav-link" to="/case-manager/work-orders-active">   ACTIVE WORK ORDER  </NavLink>
                    </li>
                    <li className="nav-item">
             <NavLink className="nav-link" to="/case-manager/work-orders-records-obtained">   RECORDS OBTAINED WORK ORDER  </NavLink>
                    </li>
                    <li className="nav-item">
             <NavLink className="nav-link" to="/case-manager/work-orders-closed">   CLOSED WORK ORDER  </NavLink>
                    </li>
                    <li className="nav-item">
             <NavLink className="nav-link" to="/case-manager/work-orders-incomplete">   INCOMPLETE WORK ORDER  </NavLink>
                    </li>
           
          </ul>
        </li>


          
            <li className="nav-item">
              <NavLink className="nav-link " to="/case-manager/patients">Patient</NavLink>
            </li>
          
                  
  


     
              

          </ul>
        </div>
       
      </div>


    </nav>

  );
};
export default TopMenu;